import { Component, Input, OnInit } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-user-detail-destinations-regions',
  templateUrl: './user-detail-destinations-regions.component.html',
  styleUrls: ['./user-detail-destinations-regions.component.css']
})
export class UserDetailDestinationsRegionsComponent implements OnInit {

  @Input()
  regions: any[];

  @Input()
  nation: any;

  expanded: boolean[];

  constructor() { }

  ngOnInit() {
    this.syncExpanded();
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.regions.forEach((item) => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  addRegion(nation: any) {
    nation.regions.push({
      name: "",
      cities: []
    });
    this.syncExpanded(true);
  }

  removeRegion(region: any, nation: any): void {
    if (!confirm("Vuoi veramente rimuovere tutta la regione " + region.name + "?")) return;
    const index = nation.regions.indexOf(region);

    if (index >= 0) {
      nation.regions.splice(index, 1);
      this.syncExpanded();
    }
  }

  addCity(event: MatChipInputEvent, region: any): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      region.cities.push({ name: value.trim() });
    }

    if (input) {
      input.value = '';
    }
  }

  removeCity(city: any, region: any): void {
    const index = region.cities.indexOf(city);

    if (index >= 0) {
      region.cities.splice(index, 1);
    }
  }

}
